<template>
  <div class="activity-page activity-page--invite">
    <div class="decor decor--a" />
    <div class="decor decor--b" />

    <header class="brand">
      <span class="brand__logo">G</span>
      <span class="brand__name">Go Trust</span>
    </header>

    <main class="main">
      <h1 class="title">
        邀请好友<br />领取课程抵扣券
      </h1>
      <p class="subtitle">好友接受邀请后，你和好友都可获得课程抵扣权益</p>

      <div class="voucher">
        <div class="voucher__left">券</div>
        <div class="voucher__right">
          <p class="voucher__amount">¥{{ amountText }}</p>
          <p class="voucher__label">课程抵扣券</p>
        </div>
      </div>

      <section class="card">
        <div class="invite-count">
          <span class="invite-count__label">当前已邀</span>
          <p class="invite-count__num">
            <em>{{ inviteCount }}</em>人
          </p>
        </div>
        <div class="divider" />
        <div class="code-row">
          <span class="code-row__label">我的邀请码</span>
          <div class="code-box">{{ referralCode || '—' }}</div>
          <button type="button" class="btn-copy" @click="onCopy">复制</button>
        </div>
      </section>

      <section class="card">
        <h2 class="card__title">请填写对方邀请码</h2>
        <div class="bind-row">
          <input
            v-model="inviterCode"
            class="bind-input"
            maxlength="32"
            placeholder="请输入邀请码"
          />
          <button
            type="button"
            class="btn-confirm"
            :disabled="binding"
            @click="onBind"
          >
            {{ binding ? '…' : '确认' }}
          </button>
        </div>
      </section>

      <section class="card">
        <h2 class="card__title">活动规则</h2>
        <ul class="rules-list">
          <li>活动有效期：以活动页面展示时间为准</li>
          <li>抵扣券可叠加，具体使用张数以下单页为准</li>
        </ul>
      </section>

      <p v-if="toast" class="toast">{{ toast }}</p>
    </main>
  </div>
</template>

<script>
import { claimInviteCoupon, fetchProfile } from '../api/activity'
import {
  getToken,
  isInApp,
  requireLogin,
  setToken,
} from '../utils/appBridge'

export default {
  name: 'ActivityInvitePage',
  data() {
    return {
      amountText: '50',
      inviteCount: 0,
      referralCode: '',
      inviterCode: '',
      binding: false,
      toast: '',
    }
  },
  created() {
    this.bootstrap()
  },
  methods: {
    showToast(msg) {
      this.toast = msg
      clearTimeout(this._toastTimer)
      this._toastTimer = setTimeout(() => {
        this.toast = ''
      }, 2200)
    },
    async bootstrap() {
      const t = getToken()
      if (t) setToken(t)
      const token = getToken()
      if (!token) {
        if (isInApp()) requireLogin()
        return
      }
      try {
        const profile = await fetchProfile(token)
        this.referralCode =
          profile?.referral_code || profile?.referralCode || ''
        const count =
          profile?.invite_count ??
          profile?.invited_count ??
          profile?.referral_count
        if (count != null && count !== '') {
          this.inviteCount = Number(count) || 0
        }
      } catch (e) {
        const msg = e?.message || ''
        if (/登录|鉴权|401|token|未授权/i.test(msg)) {
          requireLogin()
        }
      }
    },
    async onCopy() {
      const code = (this.referralCode || '').trim()
      if (!code) {
        this.showToast('暂无邀请码')
        return
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(code)
        } else {
          const input = document.createElement('input')
          input.value = code
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }
        this.showToast('已复制')
      } catch (_) {
        this.showToast('复制失败')
      }
    },
    async onBind() {
      const code = (this.inviterCode || '').trim()
      if (!code) {
        this.showToast('请输入邀请码')
        return
      }
      let token = getToken()
      if (!token) {
        if (isInApp()) requireLogin()
        this.showToast('请先登录')
        return
      }
      this.binding = true
      try {
        await claimInviteCoupon(code, token)
        this.showToast('领取成功')
        this.inviterCode = ''
      } catch (e) {
        const msg = e?.message || '领取失败，请稍后重试'
        if (/登录|鉴权|401|token|未授权/i.test(msg)) {
          requireLogin()
        }
        this.showToast(msg)
      } finally {
        this.binding = false
      }
    },
  },
}
</script>

<style scoped>
.activity-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #f3f0ea;
  color: #3d3428;
  padding: 20px 16px 40px;
  box-sizing: border-box;
}
.decor {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.decor--a {
  width: 200px;
  height: 200px;
  right: -40px;
  top: 20px;
  background: rgba(241, 122, 43, 0.12);
}
.decor--b {
  width: 140px;
  height: 140px;
  left: -40px;
  top: 260px;
  background: rgba(61, 52, 40, 0.06);
}

.brand {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}
.brand__logo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f17a2b;
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand__name {
  font-size: 16px;
  font-weight: 700;
}

.main {
  position: relative;
  z-index: 1;
  max-width: 420px;
  margin: 0 auto;
}

.title {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.3;
}
.subtitle {
  margin-top: 8px;
  font-size: 13px;
  color: #8a7f72;
  line-height: 1.5;
}

.voucher {
  margin: 20px 0 16px;
  display: flex;
  height: 84px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(241, 122, 43, 0.16);
}
.voucher__left {
  width: 72px;
  background: #f17a2b;
  color: #fff;
  font-size: 28px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}
.voucher__right {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
}
.voucher__amount {
  color: #f17a2b;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}
.voucher__label {
  margin-top: 6px;
  font-size: 13px;
  color: #8a7f72;
}

.card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}
.card__title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 12px;
}

.invite-count__label {
  font-size: 13px;
  color: #8a7f72;
}
.invite-count__num {
  margin-top: 4px;
  font-size: 14px;
  color: #3d3428;
}
.invite-count__num em {
  font-style: normal;
  font-size: 36px;
  font-weight: 800;
  color: #f17a2b;
  margin-right: 4px;
}
.divider {
  height: 1px;
  background: #eee9e1;
  margin: 14px 0;
}
.code-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.code-row__label {
  font-size: 13px;
  color: #8a7f72;
  flex-shrink: 0;
}
.code-box {
  flex: 1;
  height: 36px;
  border-radius: 10px;
  background: #f7f4ef;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.btn-copy {
  height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  background: #f17a2b;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.bind-row {
  display: flex;
  gap: 8px;
}
.bind-input {
  flex: 1;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #f7f4ef;
  padding: 0 12px;
  font-size: 16px;
  outline: none;
}
.btn-confirm {
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: #3d3428;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}
.btn-confirm:disabled {
  opacity: 0.65;
}

.rules-list {
  padding-left: 18px;
  margin: 0;
  color: #8a7f72;
  font-size: 13px;
  line-height: 1.7;
}

.toast {
  position: fixed;
  left: 50%;
  bottom: 48px;
  transform: translateX(-50%);
  background: rgba(61, 52, 40, 0.92);
  color: #fff;
  padding: 10px 16px;
  border-radius: 20px;
  font-size: 13px;
  z-index: 20;
  white-space: nowrap;
}
</style>
